const SwitchAll = {
    // 首页 ----------------------- start
    "0": "dashboard_user_guide",                            // 新手引导
    "1": "dashboard_pagefly",                                // pagefly广告 banner
    "2": "dashboard_affiliate",                             // Affiliate推广banner
    "3": "dashboard_adver",                              // app广告列表
    "4": "newFuncNums",                                // 新功能数量
    "5": "dashboard_imgQuota",                        // 图片额度获取成功弹窗
    // HTML Sitemap  ----------------------- start
    "6": "html_removebrand",                              // 免费删除商标 banner
    // 外链互换  ----------------------- start
    "7": "exchange_tip_banner",                       // 提示banner
    "8": "exchange_upgrade_tip",                       // 升级提示banner
    // 关键词research ----------------------- start
    "9": "keywords_issue",                               // 关键词research 问题banner
    // 谷歌Console ----------------------- start
    "10": "google_issue",                                 // 谷歌 问题banner
    // 及时索引  ----------------------- start
    "11": "instant_index_top",                           // 及时索引指导模块
}

export default SwitchAll;